import { render } from "./UserFields.vue?vue&type=template&id=546b80a6"
import script from "./UserFields.vue?vue&type=script&lang=js"
export * from "./UserFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/User/UserFields.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "546b80a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('546b80a6', __exports__)) {
    api.reload('546b80a6', __exports__)
  }
  
  module.hot.accept("./UserFields.vue?vue&type=template&id=546b80a6", () => {
    api.rerender('546b80a6', render)
  })

}


export default __exports__